import { useState } from 'react'
import { Button } from '../ui'
import AdminModal from '../../features/admin/components/AdminModal.jsx'
import AnnouncementList from './AnnouncementList.jsx'
import { useAnnouncements, useMarkAnnouncementsSeen } from '../../hooks/useAnnouncements.js'

/**
 * À la connexion, affiche une modale avec les annonces (notes de version) non
 * encore vues. La fermeture marque tout comme vu (une seule fois par nouveauté).
 */
export default function AnnouncementsGate() {
  const { data } = useAnnouncements()
  const markSeen = useMarkAnnouncementsSeen()
  const [dismissed, setDismissed] = useState(false)

  const unseen = (data?.items || []).filter((a) => a.unseen)
  const open = !dismissed && unseen.length > 0

  const close = () => {
    setDismissed(true)
    markSeen.mutate()
  }

  if (!open) return null

  return (
    <AdminModal
      isOpen={open}
      onClose={close}
      size="lg"
      title={unseen.length > 1 ? `${unseen.length} nouveautés` : 'Nouveauté'}
      subtitle="Ce qui a changé depuis votre dernière visite"
      footer={<Button variant="primary" onClick={close} type="button">Compris</Button>}
    >
      <AnnouncementList items={unseen} />
    </AdminModal>
  )
}
